window.loginTimer = null;